import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const dict = {
  it: {
    nav: {
      home: "Home",
      properties: "Camere & Loft",
      story: "La nostra storia",
      contact: "Contatti",
      login: "Accedi",
      book: "Prenota",
      admin: "Area Gestionale",
    },
    common: {
      backAll: "Tutte le camere e loft",
      loading: "Caricamento…",
      send: "Invia",
      sending: "Invio…",
      required: "obbligatorio",
      guests: "ospiti",
      guest: "ospite",
      bed: "letto",
      beds: "letti",
      bath: "bagno",
      baths: "bagni",
      night: "notte",
      nights: "notti",
      perNight: "a notte",
      total: "Totale",
    },
    header: {
      brandSub: "apARTments · dal 1978",
    },
    home: {
      eyebrow: "Associazione Culturale Il Melograno · Dal 1978",
      titleA: "Un luogo che accoglie",
      titleB: "culture, incontri",
      titleC: "e",
      titleD: "momenti di gioia.",
      subtitle: "Camere con bagno privato e loft luminosi, curati nei dettagli, nel cuore di un'associazione culturale attiva da oltre quarant'anni. Ricambio d'aria, aria condizionata, Chromecast, Wi-Fi.",
      browse: "Esplora camere e loft",
      contact: "Contattaci",
      testimonial: "\"Un ambiente caldo, ricercato e conviviale!\"",
      recentGuests: "— Ospiti recenti",
      amenities: [
        "Wi-Fi veloce in tutte le stanze",
        "Aria condizionata & ricambio d'aria",
        "TV con Chromecast",
        "Ambiente conviviale",
      ],
      storyEyebrow: "La nostra storia",
      storyTitleA: "Dal 1978, un'associazione",
      storyTitleB: "viva",
      storyBody: "Nata per promuovere l'incontro tra persone di culture, estrazione sociale e nazionalità diverse, l'Associazione Culturale Il Melograno è diventata negli anni una delle realtà più attive della regione in ambito culturale. Con il progetto apARTments, nato dopo la pandemia del 2020, offriamo camere e loft per accogliere ospiti con cui condividere gioia e scambio culturale.",
      storyMore: "Scopri di più",
      bentoBadge: "Dal 1978",
      bentoQuote: "Un ambiente caldo, ricercato e conviviale.",
      ctaEyebrow: "Vieni a trovarci",
      ctaTitle: "Prenota la tua camera o loft.",
      ctaSubtitle: "Scrivici o compila il modulo di richiesta: riceverai conferma dal nostro staff.",
      ctaAvail: "Vedi disponibilità",
    },
    properties: {
      eyebrow: "Camere & Loft",
      titleA: "Ambienti luminosi,",
      titleB: "nuovi arredi",
      titleC: ", dettagli curati.",
      subtitle: "Scegli la stanza con bagno privato o un loft indipendente. Tutti gli spazi sono dotati di Wi-Fi, aria condizionata, ricambio d'aria e Chromecast.",
      all: "Tutte",
      rooms: "Camere",
      lofts: "Loft",
      room: "Camera",
      loft: "Loft",
    },
    detail: {
      house: "La casa",
      services: "Servizi",
      requestBooking: "Richiedi prenotazione",
      yourName: "Nome",
      yourEmail: "Email",
      phone: "Telefono",
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Ospiti",
      message: "Messaggio",
      sendRequest: "Invia richiesta",
      selectDate: "Seleziona data",
      disclaimer: "Non è un pagamento. Ti confermeremo disponibilità e prezzo per email.",
      success: "Richiesta inviata! Ti risponderemo a breve.",
      errorGeneric: "Errore nell'invio",
    },
    contact: {
      eyebrow: "Scrivici",
      titleA: "Facci sapere",
      titleB: "quando",
      titleC: "vieni a trovarci.",
      subtitle: "Siamo lieti di rispondere a qualsiasi domanda su camere, loft o iniziative culturali dell'Associazione.",
      subject: "Oggetto",
      body: "Messaggio",
      submit: "Invia messaggio",
      success: "Messaggio inviato! Ti risponderemo presto.",
      email: "Email",
      phone: "Telefono",
      seat: "Sede",
      seatValue: "Via Novara, 25, Castellanza, Italia",
    },
    story: {
      eyebrow: "Associazione Culturale Il Melograno",
      titleA: "Dal 1978, per",
      titleB: "l'incontro",
      titleC: ".",
      intro: "L'associazione nasce nel 1978 per promuovere l'incontro tra persone di culture, estrazione sociale e nazionalità diverse.",
      projectEyebrow: "Il progetto apARTments",
      projectTitle: "Camere e loft ricercati.",
      p1: "Il nuovo Progetto apARTments offre la scelta tra stanze con bagno e loft per accogliere gli ospiti in un ambiente caldo e ricercato. Le stanze e i loft sono luminosi, dotati di nuovi arredi, impianti di ricambio d'aria e condizionamento, televisione con Chromecast e Wi-Fi.",
      p2: "Molteplici sono state le iniziative culturali e ricreative nel corso degli anni, tanto da rendere Il Melograno una delle realtà più attive della regione in ambito culturale.",
      p3: "La pandemia del 2020 ci ha obbligato a rivedere la programmazione delle iniziative e a ristrutturare gli spazi dell'Associazione, realizzando apARTments. L'obiettivo del progetto è promuovere occasioni di incontro e conoscenza, accogliendo al meglio i nostri ospiti con i quali condividere momenti di gioia e di scambio culturale.",
    },
    footer: {
      about: "Un'associazione culturale che dal 1978 promuove l'incontro fra persone di culture, estrazione sociale e nazionalità diverse. Il progetto apARTments accoglie i nostri ospiti in un ambiente caldo e ricercato.",
      navigate: "Naviga",
      contact: "Contatti",
      copyright: "Associazione Culturale Il Melograno — Progetto apARTments",
      staffLogin: "Accesso Staff",
    },
    login: {
      title: "Area Gestionale",
      subtitle: "Accedi per gestire proprietà, calendario e messaggi.",
      email: "Email",
      password: "Password",
      submit: "Accedi",
      submitting: "Accesso…",
      welcome: "Benvenuto",
      error: "Errore di accesso",
    },
  },
  en: {
    nav: {
      home: "Home",
      properties: "Rooms & Lofts",
      story: "Our story",
      contact: "Contact",
      login: "Sign in",
      book: "Book now",
      admin: "Dashboard",
    },
    common: {
      backAll: "All rooms & lofts",
      loading: "Loading…",
      send: "Send",
      sending: "Sending…",
      required: "required",
      guests: "guests",
      guest: "guest",
      bed: "bed",
      beds: "beds",
      bath: "bath",
      baths: "baths",
      night: "night",
      nights: "nights",
      perNight: "per night",
      total: "Total",
    },
    header: {
      brandSub: "apARTments · since 1978",
    },
    home: {
      eyebrow: "Il Melograno Cultural Association · Since 1978",
      titleA: "A place that welcomes",
      titleB: "cultures, encounters",
      titleC: "and",
      titleD: "moments of joy.",
      subtitle: "En-suite rooms and bright lofts, carefully designed, at the heart of a cultural association active for over forty years. Fresh-air system, air conditioning, Chromecast, Wi-Fi.",
      browse: "Explore rooms & lofts",
      contact: "Contact us",
      testimonial: "\"A warm, refined and convivial place!\"",
      recentGuests: "— Recent guests",
      amenities: [
        "Fast Wi-Fi in every room",
        "Air conditioning & fresh-air system",
        "TV with Chromecast",
        "Convivial atmosphere",
      ],
      storyEyebrow: "Our story",
      storyTitleA: "Since 1978, a",
      storyTitleB: "living association",
      storyBody: "Born to promote encounters between people of different cultures, backgrounds and nationalities, Il Melograno has become one of the region's most active cultural realities. With the apARTments project, launched after the 2020 pandemic, we offer rooms and lofts to welcome guests to share joy and cultural exchange.",
      storyMore: "Learn more",
      bentoBadge: "Since 1978",
      bentoQuote: "A warm, refined and convivial place.",
      ctaEyebrow: "Come visit us",
      ctaTitle: "Book your room or loft.",
      ctaSubtitle: "Write to us or fill out the request form: our staff will confirm shortly.",
      ctaAvail: "Check availability",
    },
    properties: {
      eyebrow: "Rooms & Lofts",
      titleA: "Bright spaces,",
      titleB: "new furnishings",
      titleC: ", curated details.",
      subtitle: "Choose an en-suite room or a self-contained loft. All spaces feature Wi-Fi, air conditioning, fresh-air system and Chromecast.",
      all: "All",
      rooms: "Rooms",
      lofts: "Lofts",
      room: "Room",
      loft: "Loft",
    },
    detail: {
      house: "The space",
      services: "Amenities",
      requestBooking: "Request booking",
      yourName: "Name",
      yourEmail: "Email",
      phone: "Phone",
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Guests",
      message: "Message",
      sendRequest: "Send request",
      selectDate: "Select a date",
      disclaimer: "This is not a payment. We'll confirm availability and price by email.",
      success: "Request sent! We'll reply shortly.",
      errorGeneric: "Sending error",
    },
    contact: {
      eyebrow: "Write to us",
      titleA: "Let us know",
      titleB: "when",
      titleC: "you'll visit.",
      subtitle: "We're happy to answer any question about rooms, lofts, or the Association's cultural initiatives.",
      subject: "Subject",
      body: "Message",
      submit: "Send message",
      success: "Message sent! We'll reply soon.",
      email: "Email",
      phone: "Phone",
      seat: "Address",
      seatValue: "Via Novara, 25, Castellanza, Italy",
    },
    story: {
      eyebrow: "Il Melograno Cultural Association",
      titleA: "Since 1978, for",
      titleB: "encounters",
      titleC: ".",
      intro: "The Association was founded in 1978 to promote encounters between people of different cultures, social backgrounds and nationalities.",
      projectEyebrow: "The apARTments project",
      projectTitle: "Refined rooms and lofts.",
      p1: "The new apARTments project offers a choice between en-suite rooms and self-contained lofts to welcome guests in a warm and refined environment. Rooms and lofts are bright and feature new furnishings, fresh-air and air-conditioning systems, TV with Chromecast, and Wi-Fi.",
      p2: "Over the years many cultural and recreational initiatives have made Il Melograno one of the region's most active cultural realities.",
      p3: "The 2020 pandemic forced us to review our programming and renovate the Association's spaces, giving life to apARTments. The project aims to promote occasions for meeting and mutual discovery, welcoming guests to share moments of joy and cultural exchange.",
    },
    footer: {
      about: "A cultural association that since 1978 has promoted encounters between people of different cultures, backgrounds and nationalities. The apARTments project welcomes guests to a warm and refined space.",
      navigate: "Navigate",
      contact: "Contact",
      copyright: "Il Melograno Cultural Association — apARTments Project",
      staffLogin: "Staff Login",
    },
    login: {
      title: "Dashboard",
      subtitle: "Sign in to manage properties, calendar and messages.",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      submitting: "Signing in…",
      welcome: "Welcome",
      error: "Sign-in error",
    },
  },
};

const Ctx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mel_lang") || "it");
  useEffect(() => { localStorage.setItem("mel_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = dict[lang];
  const toggle = useCallback(() => setLang((l) => l === "it" ? "en" : "it"), []);
  return <Ctx.Provider value={{ lang, setLang, toggle, t }}>{children}</Ctx.Provider>;
}

export const useLang = () => useContext(Ctx);
